// extracted by mini-css-extract-plugin
module.exports = {"dialogOutter":"DeleteConfirmationDialog_dialogOutter__28XU4","buttonGroup":"DeleteConfirmationDialog_buttonGroup__3Bqsb"};